import React from 'react';

export default ( props ) => {
	let style = props.style ? props.style : {},
		extraClassName = props.className ? `  ${ props.className }` : '',
		hasContainer = !!( props.container !== false || props.containerClass ),
		containerClass = props.containerClass ? props.containerClass : '';

	let loader = <div className={ `loader-css${ extraClassName }` } style={ style }><div /></div>;

	return hasContainer === false ? loader : <div className={ containerClass }>{ loader }</div>;
};



// WEBPACK FOOTER //
// ./src/components/common/LoaderCssComponent.js